import { gql } from '@apollo/client/core';
import { IdTokenClaims } from '@azure/msal-browser';

export interface LoginMutationData {
  tokens: {
    access: string;
    refresh: string;
  };
}

export interface LoginMutationVariables {
  token?: IdTokenClaims & {
    [key: string]: string | number | string[] | object | undefined | unknown;
  };
  password?: string;
}

export const LOGIN_MUTATION = gql`
  mutation authLogin($token: UserCreateInput, $password: String) {
    tokens: authLogin(token: $token, password: $password) {
      access: accessToken
      refresh: refreshToken
    }
  }
`;
